import {
    Button,
    Card,
    CardContent,
    Grid,
    InputBase,
    TextField,
} from '@mui/material';
import { google as generateCalendarLink } from 'calendar-link';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import { addToLocalList } from '../../store/slices/localSlice';

export default function StudyReminderAddScreen() {
    const [reminder, setReminder] = useState('');
    const [time, setTime] = useState('');
    const [date, setDate] = useState('');

    const event = {
        title: 'Bible study reminder',
        description: reminder,
        start: `${date} ${time}:00`,
        duration: [0, 'hour'],
    };

    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const submitReminder = () => {
        if (reminder.length < 10) {
            enqueueSnackbar('Text is too short', { variant: 'error' });
            return;
        }
        if (time.length < 2) {
            enqueueSnackbar('Please set the time', { variant: 'error' });
            return;
        }

        dispatch(
            addToLocalList({
                list: 'reminders',
                data: { reminder, date, time },
            })
        );
        alert('Opening Calendar');
        const link = generateCalendarLink(event);
        window.open(link, '_blank');
        navigate(-1);
    };

    return (
        <Screen authPass title={'Add Reminder'}>
            <Grid item xs={12}>
                <TextField
                    placeholder="Date"
                    label="Date"
                    className="mb-2"
                    fullWidth
                    type="date"
                    variant="outlined"
                    onChange={(e) => setDate(e.target.value)}
                />
                <TextField
                    placeholder="Time"
                    label="Time"
                    className="mb-2"
                    fullWidth
                    type="time"
                    variant="outlined"
                    onChange={(e) => setTime(e.target.value)}
                />
                <Card variant="outlined">
                    <CardContent>
                        <InputBase
                            multiline
                            rows={4}
                            fullWidth
                            placeholder="Type here"
                            onChange={(e) => setReminder(e.target.value)}
                        />
                    </CardContent>
                </Card>
                <Button
                    variant="contained"
                    onClick={submitReminder}
                    className="mt-3"
                >
                    Add Reminder
                </Button>
            </Grid>
        </Screen>
    );
}
